import React from 'react';
import { useIntl } from 'react-intl/dist';

const Image = props => {

    const {
        source,
        desc,
        name,
        classes,
        isMessageFormattingEnabled=true
    } = props;
    const intl = useIntl();
    return (
        <img
            src={source}
            alt={isMessageFormattingEnabled?intl.formatMessage( { id: desc } ):desc}
            className={classes && classes.join(' ')}
            id={name}
            data-automation-id={name}/>
    );
};


export default Image;
